__turbopack_context__.v({
  "fullscreen": "jehsya_fullscreen",
});
